import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import {StaticImage} from "gatsby-plugin-image";
function GameScreen(props) {
    return (
        <section className="gaming_screen p50">
            <Container>
                <Row >
                    <Col className="text-center">
                        <h2>Gaming For All Screens</h2>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={3}>
                        <div className="game_service">
                            <div className="game_img_box">
                                <StaticImage
                                    src="../../images/services-usa/game_update/web_game.svg"
                                    alt="tekrevol_web_game"
                                    className="img-fluid"
                                    layout="constrained"
                                    placeholder="blurred"
                                    formats={["webp"]}
                                    width={85}
                                    height={85}
                                />
                            </div>
                            <h3>Web Gaming</h3>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                        <div className="game_service">
                            <div className="game_img_box">
                                <StaticImage
                                    src="../../images/services-usa/game_update/mobile_game.svg"
                                    alt="tekrevol_web_game"
                                    className="img-fluid"
                                    layout="constrained"
                                    placeholder="blurred"
                                    formats={["webp"]}
                                    width={72}
                                    height={100}
                                />
                            </div>
                            <h3>Mobile Gaming</h3>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                        <div className="game_service">
                            <div className="game_img_box">
                                <StaticImage
                                    src="../../images/services-usa/game_update/vr_game.svg"
                                    alt="tekrevol_web_game"
                                    className="img-fluid"
                                    layout="constrained"
                                    placeholder="blurred"
                                    formats={["webp"]}
                                    width={99}
                                    height={85}
                                />
                            </div>
                            <h3>VR Gaming</h3>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={3}>
                        <div className="game_service">
                            <div className="game_img_box">
                                <StaticImage
                                    src="../../images/services-usa/game_update/tv_game.svg"
                                    alt="tekrevol_web_game"
                                    className="img-fluid"
                                    layout="constrained"
                                    placeholder="blurred"
                                    formats={["webp"]}
                                    width={90}
                                    height={85}
                                />
                            </div>
                            <h3>TV Gaming</h3>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default GameScreen;